import React from "react";

type ConeIconProps = {
  size?: number;
  color?: string;
};

export default function ConeIcon({ size = 24, color = "#000000" }: ConeIconProps) {
  const stroke = "#222222";
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <path
        d="M8 3h8l4 14H4L8 3z"
        fill={color}
        stroke={stroke}
        strokeWidth="1"
        strokeLinejoin="round"
      />
      <path
        d="M3.5 19.5h17"
        stroke={stroke}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

